/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContractorWriteRequest
 */
export interface ContractorWriteRequest {
    /**
     * 
     * @type {string}
     * @memberof ContractorWriteRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof ContractorWriteRequest
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof ContractorWriteRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ContractorWriteRequest
     */
    type: string;
}

/**
 * Check if a given object implements the ContractorWriteRequest interface.
 */
export function instanceOfContractorWriteRequest(value: object): value is ContractorWriteRequest {
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function ContractorWriteRequestFromJSON(json: any): ContractorWriteRequest {
    return ContractorWriteRequestFromJSONTyped(json, false);
}

export function ContractorWriteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractorWriteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'],
        'type': json['type'],
    };
}

export function ContractorWriteRequestToJSON(json: any): ContractorWriteRequest {
    return ContractorWriteRequestToJSONTyped(json, false);
}

export function ContractorWriteRequestToJSONTyped(value?: ContractorWriteRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'type': value['type'],
    };
}

